export default {
	name: 'task_0_1',
	description: 'Заставка',
	title: 'Режим прохождения игры',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите, в каком порядке вам будут задаваться задачи",
			options: ["Случайные задачи", "Прямой порядок"],
			correct: [0]
        };
	},
	isCompleted: () => true,
};